import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ContactInput = ({ phone, setPhone, countryCode, setCountryCode }) => {
  return (
    <PhoneInput
      className={"border-0 focus-none"}
      country={countryCode}
      enableSearch={true}
      value={phone}
      inputStyle={{
        width: "100%",
        height: "42px",
        border: "0px solid #DFE5E0",
        outline: "none",
        borderRadius: "8px",
        backgroundColor: "#EFF6FA",
      }}
      inputProps={{
        placeholder: "",
      }}
      searchPlaceholder="Search"
      placeholder=""
      onChange={(phone, country) => {
        setPhone("+" + phone);
        setCountryCode(country?.countryCode);
      }}
    />
  );
};

export default ContactInput;
